import { useNavigate } from 'react-router-dom'

interface TagPillsProps {
  tags: string[]
  maxVisible?: number
}

export function TagPills({ tags, maxVisible = 3 }: TagPillsProps) {
  const navigate = useNavigate()

  if (tags.length === 0) return null

  const visible = tags.slice(0, maxVisible)
  const overflow = tags.length - maxVisible

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 6,
        padding: '8px 16px',
      }}
    >
      {visible.map((tag) => (
        <button
          key={tag}
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            navigate(`/?tag=${encodeURIComponent(tag)}`)
          }}
          style={{
            display: 'inline-block',
            padding: '2px 10px',
            borderRadius: 9999,
            background: 'color-mix(in srgb, var(--brand) 10%, transparent)',
            color: 'var(--brand)',
            border: 'none',
            fontFamily: 'var(--font-sans)',
            fontSize: 12,
            fontWeight: 500,
            cursor: 'pointer',
            transition: 'background var(--dur-fast)',
            lineHeight: '20px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = 'color-mix(in srgb, var(--brand) 18%, transparent)'
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = 'color-mix(in srgb, var(--brand) 10%, transparent)'
          }}
        >
          #{tag}
        </button>
      ))}
      {overflow > 0 && (
        <span
          style={{
            display: 'inline-block',
            padding: '2px 10px',
            borderRadius: 9999,
            background: 'var(--surface-2)',
            color: 'var(--text-muted)',
            fontFamily: 'var(--font-sans)',
            fontSize: 12,
            fontWeight: 500,
            lineHeight: '20px',
            border: '1px solid var(--border)',
          }}
        >
          +{overflow}
        </span>
      )}
    </div>
  )
}
